export default __webpack_public_path__ + "assets/icons/iconPath.b926abda.svg";